import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { Slot } from "@radix-ui/react-slot";
import type { CSSProperties } from "react";
import { forwardRef } from "react";

import useDocumentSize from "@/hooks/useDocumentSize";
import useTopLeft from "@/hooks/useTopLeft";

type Props = { asChild?: boolean } & JSX.IntrinsicElements["div"];

/**
 * Vertical（縦）方向にdiv要素でビューポートを埋めるユーティリティコンポーネント
 */
const FillScreen = forwardRef<HTMLDivElement, Props>(
  function FillScreen(props, ref) {
    const { asChild, style, ...rest } = props;
    const size = useDocumentSize();
    const { refCallback, topLeft } = useTopLeft<HTMLDivElement>();

    const height: CSSProperties["height"] = size.height - (topLeft?.top ?? 0);
    const composedRefs = useComposedRefs(refCallback, ref);
    const Comp = asChild ? Slot : "div";
    return <Comp ref={composedRefs} style={{ height, ...style }} {...rest} />;
  },
);
export default FillScreen;
